module.exports = __webpack_public_path__ + "img/read.981ebbe0.svg";